// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { setLpad, setChartBgColor, setChartBdColor, setMixedChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	getStart_: ({ searchParams }) => searchParams.startMonth,
	getEnd_: ({ searchParams }) => searchParams.endMonth,
	dayCols_: ({ searchParams: { startMonth, endMonth }, gridCarList }) => {
		//console.log('값이 뭐지', gridCarList);
		let cols = [];
		let col = {
			label: '차종',
			prop: 'carCd',
			width: '120px',
			sortable: false,
			form: {
				type: 'select',
				options: gridCarList,
				isDisabled: ({}) => true
				/* 에디터 막는다.
				,isDisabled({ row }) {
					if (row.rowType && row.rowType === 'add') return false;
					else return true;
				}
				*/
				// MWCC000355
			}
		};

		cols.push(col);

		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month(); // moment 특성상 0 - 11 이기 때문
		let endYr = moment(endMonth).year();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		// 해(year) 부터 먼저 만든다.
		for (let year = strYr; year <= endYr; year++) {
			let newCol = {
				label: '' + year,
				minWidth: '150px',
				sortable: false,
				children: []
			};
			cols.push(newCol);
		}

		// 달(month)를 만든 후, 일치하는 해(year)의 children에 추가한다.
		let propI = 0;
		for (let i = strMo; i < strMo + diffMonth + 1; i++) {
			const year = strYr + Math.floor(i / 12) + '';
			const month = (i % 12) + 1;
			const child = {
				label: setLpad(month, 2, '0') + '',
				prop: 'col' + propI,
				minWidth: '80px'
			};
			cols.forEach(col => {
				if (col.label === year) {
					col.children.push(child);
				}
			});
			propI++;
		}

		//console.log('컬럼 값음', JSON.stringify(cols));
		return cols;
	},
	colExcel_: ({ searchParams: { startMonth, endMonth } }) => {
		//console.log('값이 뭐지', gridCarList);
		let cols = [];
		let col = {
			label: '차종',
			prop: 'carNm',
			width: '120px',
			sortable: false
		};

		cols.push(col);

		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month(); // moment 특성상 0 - 11 이기 때문
		let endYr = moment(endMonth).year();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		// 달(month)를 만든 후, 일치하는 해(year)의 children에 추가한다.
		let propI = 0;
		for (let i = strMo; i < strMo + diffMonth + 1; i++) {
			const year = strYr + Math.floor(i / 12) + '';
			const month = (i % 12) + 1;
			const tmpLabel = String(year + '-' + setLpad(month, 2, '0'));
			//순수 숫자가 컬럼명일때
			//const tmpLabel = String(year + setLpad(month, 2, '0'));

			//console.log('타입종류>>', typeof tmpLabel);

			let child = {
				//순수 숫자가 컬럼명일(예를들어년도일경우)경우 뒤에 공백붙여줘야 엑셀다운로드시 정렬이되어진다.
				//label: tmpLabel + ' ',
				label: tmpLabel,
				prop: 'col' + propI,
				minWidth: '80px'
			};

			propI++;
			cols.push(child);
		}

		//console.log('컬럼 값음', JSON.stringify(cols));
		return cols;
	},
	stackedLabel_: () => {
		// 바 스택차트 레이블 (전년도,올해년도 현재날짜를 가져와서 넣는다.)
		let toYear = moment().year() + '';
		let fromYear = moment().subtract(1, 'years').format('yyyy');

		let labelArray = [];

		labelArray.push(fromYear);
		labelArray.push(toYear);

		return labelArray;
	},
	stackedDataSet_: ({ graphBarStackChartInfo }) => {
		// 바 스택차트 데이터셋 셋팅 ()
		let cols = [];

		//console.log('값은infor<,<<<<', graphBarStackChartInfo);
		//console.log('값은infor<,<<<<', graphBarStackChartInfo.length);
		//console.log('값은carNm<,<<<<', graphBarStackChartInfo[0].carNm);

		for (let i = 0; i < graphBarStackChartInfo.length; i++) {
			let carNm = graphBarStackChartInfo[i].carNm;
			let lastSalesCnt = graphBarStackChartInfo[i].lastSalesCnt;
			let curSalesCnt = graphBarStackChartInfo[i].curSalesCnt;
			let carCd = graphBarStackChartInfo[i].carCd;
			let newCol = {
				type: 'bar',
				label: carNm,
				data: [lastSalesCnt, curSalesCnt],
				dataKey: [carCd],
				backgroundColor: setChartBgColor(i)
				//borderColor: setChartBdColor(i),
				//borderWidth: 1
			};
			cols.push(newCol);
		}

		//console.log('debug>>>>>', cols);
		return cols;
	},
	doughnutLabel_: ({ graphPieResultList }) => {
		// 바 스택차트 레이블 (전년도,올해년도 현재날짜를 가져와서 넣는다.)
		let labelArray = [];
		for (let i = 0; i < graphPieResultList.length; i++) {
			labelArray.push(graphPieResultList[i].carNm);
		}
		return labelArray;
	},
	doughnutDataSet_: ({ graphPieResultList }) => {
		// 바 스택차트 데이터셋 셋팅 ()
		let cols = [];

		let colsData = [];
		let bgColor = [];

		//데이터를 만든다.
		for (let i = 0; i < graphPieResultList.length; i++) {
			let salesTotCnt = graphPieResultList[i].salesTotCnt;
			colsData.push(salesTotCnt);
			bgColor.push(setChartBgColor(i));
		}

		let newCol = {
			data: colsData,
			backgroundColor: bgColor,
			borderColor: '#eee',
			hoverBorderColor: '#eee'
			//borderColor: setChartBdColor(i),
			//borderWidth: 1
		};

		cols.push(newCol);
		//console.log('debug>>>>>', cols);
		return cols;
	},
	LineChartLabel_: ({ searchParams: { startMonth, endMonth } }) => {
		//console.log('값이 뭐지', gridCarList);
		let cols = [];

		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month(); // moment 특성상 0 - 11 이기 때문
		let endYr = moment(endMonth).year();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		// 달(month)를 만든 후, 일치하는 해(year)의 children에 추가한다.

		for (let i = strMo; i < strMo + diffMonth + 1; i++) {
			const year = strYr + Math.floor(i / 12) + '';
			const month = (i % 12) + 1;
			const tmpLabel = String(year + '-' + setLpad(month, 2, '0'));
			//순수 숫자가 컬럼명일때
			//const tmpLabel = String(year + setLpad(month, 2, '0'));

			cols.push(tmpLabel);
		}

		//console.log('컬럼 값음>>>', JSON.stringify(cols));
		return cols;
	},
	lineDataSet_: ({ graphLineChartInfo }) => {
		// 바 스택차트 데이터셋 셋팅 ()
		let cols = [];

		let colsData = [];
		let bgColor = [];
		let tmpLabel = '';
		let carCd = [];
		let tmpCarCd = '';
		let newCol = {};

		//데이터를 만든다.
		for (let i = 0; i < graphLineChartInfo.length; i++) {
			if (tmpCarCd != graphLineChartInfo[i].carCd) {
				carCd.push(graphLineChartInfo[i].carCd);
				tmpCarCd = graphLineChartInfo[i].carCd;
			}
		}

		//console.log('컬럼값은>>>', carCd.length);

		for (let j = 0; j < carCd.length; j++) {
			for (let k = 0; k < graphLineChartInfo.length; k++) {
				//console.log('값은 carCd>>', carCd[j]);
				//console.log('값은 graphLineChartInfo[k].carCd>>', graphLineChartInfo[k].carCd);

				if (carCd[j] == graphLineChartInfo[k].carCd) {
					colsData.push(graphLineChartInfo[k].salesTotCnt);
					tmpLabel = graphLineChartInfo[k].carNm;
					//console.log('가나다라>>>>>>', graphLineChartInfo[k].salesTotCnt);
				}
			} // end k

			let newCol = {
				label: tmpLabel,
				data: colsData,
				borderColor: setChartBdColor(j)
			};

			//console.log('푸시한다.');
			//데이터 및 라벨을 초기화해야됨.
			colsData = [];
			tmpLabel = '';
			cols.push(newCol);
		} // end j

		//console.log('뭐지 >>>>>', cols);
		return cols;
	},

	MixedDataSet_: ({ graphMixedChartInfo }) => {
		// 바 스택차트 데이터셋 셋팅 ()
		let cols = [];

		//console.log('여기값은>>>>>>>>', graphMixedChartInfo);

		let barData1 = [];
		let barData2 = [];
		let lineData = [];

		let bgColor1 = [];
		let bgColor2 = [];
		let bgColor3 = [];

		let tmpLabel = '';
		let carCd = [];
		let tmpCarCd = '';
		let newCol = {};

		//바차트
		for (let k = 0; k < graphMixedChartInfo.length; k++) {
			barData1.push(graphMixedChartInfo[k].saleCnt);
			barData2.push(graphMixedChartInfo[k].aceptCnt);
			lineData.push(graphMixedChartInfo[k].defectRto);
		} //

		let barCol1 = {
			type: 'bar',
			label: '판매건수',
			data: barData1,
			borderColor: setMixedChartBdColor(0),
			backgroundColor: setMixedChartBdColor(0)
		};

		cols.push(barCol1);

		let barCol2 = {
			type: 'bar',
			label: '확정건수',
			data: barData2,
			borderColor: setMixedChartBdColor(1),
			backgroundColor: setMixedChartBdColor(1)
		};

		cols.push(barCol2);

		let lineCol = {
			type: 'line',
			label: '불량율',
			data: lineData,
			borderColor: setMixedChartBdColor(2)
		};

		cols.push(lineCol);

		//console.log('뭐지이거 리턴인가? >>>>>', cols);
		return cols;
	}

	/*
	
		{
						label: '아반때0',
						borderColor: 'rgba(255,99,132,1)', // 선 색상
						data: [7,3,4,5,6,7,8,]
						// tension: 0.1 //선 직선으로 표시 1로 하면 곡선으로 표시
					},
					{
						label: '장기 재고 금액',
						borderColor: 'rgba(54, 162, 235, 1)', //선 색상
						data: [100, 300, 30000, 1000]
						// tension: 0.1 //선 직선으로 표시 1로 하면 곡선으로 표시
					}
	
	*/
};
